import React from 'react';

import { Text } from '@opendoor/bricks-next';

export interface ErrorPromptProps {
  message: string;
}

/**
 * Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
 */
export const ErrorPrompt: React.FC<ErrorPromptProps> = ({ message }) => {
  return (
    <Text
      data-testid="error-prompt"
      tag="span"
      typography="$bodySmall"
      color="$contentStateErrorDefault"
      marginTop="$1dot5x"
    >
      {message}
    </Text>
  );
};
